import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { API_SERVER_TOKEN } from "@portal-front-end/api";
import { Observable } from "rxjs";
import { PromotionCodeType } from '@portal-front-end/models';


@Injectable({ providedIn: 'root' })

export class PromotionCodeApiService {
    
    constructor(
        private readonly http: HttpClient,
        @Inject(API_SERVER_TOKEN) private apiServer: string
    ) { }

    private readonly PROMOTION_CODE_URL = `${this.apiServer}/promotion-code`;

    getPromotionCode(requestParams):Observable<PromotionCodeType[]>{
        return this.http.get<PromotionCodeType[]>(`${this.PROMOTION_CODE_URL}`,
        {
            params: requestParams
        });
    }
}